import { render, staticRenderFns } from "./SystemRecording.vue?vue&type=template&id=6522346c"
import script from "./SystemRecording.vue?vue&type=script&lang=js"
export * from "./SystemRecording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports